import React from "react";
import { menuItemsfour } from "./menuItems";
import "./dropdowns.css";
import { Link } from "react-router-dom";

const Dropdownfour = ({ closeMenu }) => {
  return (
    <ul className="media-submenu show">
      {menuItemsfour.map((item) => (
        <li key={item.id} onClick={() => closeMenu && closeMenu()}>
          <Link to={item.path} className="submenu-item">
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Dropdownfour;
